import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { version } from "react";

import templateVersionService from "services/templateVersion";

export const getTemplateVersionsAsync = createAsyncThunk(
  "templateVersions/getTemplateVersionsAsync",
  async (queryParams, thunkAPI) => {
    try {
      const res = await templateVersionService.getAll(queryParams);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const addTemplateVersionAsync = createAsyncThunk(
  "templateVersions/addTemplateVersionAsync",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await templateVersionService.create(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editTemplateVersionAsync = createAsyncThunk(
  "templateVersions/editTemplateVersionAsync",
  async ({ templateVersionId, data }) => {
    const res = await templateVersionService.update(templateVersionId, data);
    return res.data;
  }
);

export const deleteTemplateVersionAsync = createAsyncThunk(
  "templateVersions/deleteTemplateVersionAsync",
  async ({ templateVersionId }) => {
    const res = await templateVersionService.remove(templateVersionId);
    return res.data;
  }
);

export const deleteDraftTemplateVersionAsync = createAsyncThunk(
  "templateVersions/deleteDraftTemplateVersionAsync",
  async ({ templateVersionId }, { rejectWithValue }) => {
    try {
      const res = await templateVersionService.removeHard(templateVersionId);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const templateVersionSlice = createSlice({
  name: "templateVersions",
  initialState: {
    templateVersions: {
      items: [],
      totalCount: 0,
    },
    version: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTemplateVersionsAsync.fulfilled, (state, action) => {
        state.templateVersions = action.payload;
      })
      .addCase(addTemplateVersionAsync.fulfilled, (state, action) => {
        state.version = action.payload;
      })
      .addCase(editTemplateVersionAsync.fulfilled, (state, action) => {
        state.version = action.payload;
      });
  },
});

export default templateVersionSlice.reducer;
